import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";
import store from '@/state/store';
import { recordPage } from '@/helpers/recent-pages';

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('jwt'); // for all requests
  //check if valid user and token, else redirect to login
  // const userId = localStorage.getItem('userid') ?? null;
  // await axios.get(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/users/${userId}`).then((response) => {
  //   localStorage.setItem("userdata", JSON.stringify(response.data.data));
  //   localStorage.setItem("user", JSON.stringify(response.data.data));
  //   next();
  // }).catch(() => {
  //   next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  // });
  if (localStorage.getItem('user')) {
    next();
  }
  else
  {
    next({ name: "login", query: { redirectFrom: routeTo.fullPath } });
  }
  
});

router.beforeEach((routeTo, routeFrom, next) => {
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {

    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();

    // If auth is required and the user is logged in...
    if (store.getters['auth/loggedIn']) {
      // Validate the local user token...
      return store.dispatch('auth/validate').then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser ? next() : redirectToLogin();
      });
    }
    // console.log(routeTo);

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin();

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  } else {
    const publicPages = ['login', 'Register', 'Forgot password', 'PurchaseRequestApprovalExt', 'Reset Password', 'ExtAccreditationTemplate'];
    const authpage = !publicPages.includes(routeTo.name);
    const loggeduser = localStorage.getItem('user');

    if (authpage && !loggeduser) {
      return next('/login');
    }

    next();
  }
});



// The pages visited, for the home page's "Recently visited".
router.afterEach((to) => recordPage(to));

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  // Sentinel so an intentional redirect can be told apart from a real failure.
  const REDIRECTED = Symbol('redirected');

  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (!route.meta || !route.meta.beforeResolve) {
          resolve();
          return;
        }

        try {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              // The hook chose to redirect; it owns the navigation from here.
              next(...args);
              reject(REDIRECTED);
            } else {
              resolve();
            }
          });
        } catch (hookError) {
          // A hook that throws must not leave the promise pending, or the
          // navigation hangs and the page simply never changes.
          reject(hookError);
        }
      });
    }
  } catch (error) {
    if (error === REDIRECTED) {
      // next() was already called with the redirect target.
      return;
    }

    // Any other failure is the hook's problem, not the navigation's. Letting it
    // fall through here would abort the navigation silently, which looks to the
    // user like the menu simply not responding.
    console.error('beforeResolve hook failed; continuing navigation:', error);
  }

  document.title = `${routeTo.meta.title ?? ''} | ${appConfig.title}`.replace(/^ \| /, '');

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
